export default "__VITE_ASSET__DmN9qv8m__"